import axios from 'axios';
import config from '../../config'; // ajuste conforme sua configuração

const EditaPermissao = async (formData, csrfToken) => {

  try {
    const response = await axios.post(`${config.URL_SERVER}/execute-procedure`, {
      proc: 'FRONT_Permissao_Editar',
      requestData: {
        ID_Usuario_Controle: formData.ID_Usuario_Controle,
        ID_Permissao: formData.ID_Permissao,       
        ID_Empresa: formData.ID_Empresa,
        ID_Planta: formData.ID_Planta || null,
        ID_Empresa_Parceira: formData.ID_Empresa_Destino,
        ID_Planta_Parceira: formData.ID_Planta_Destino || null,
        ID_Documento: formData.ID_Documento || null,
        ID_Documento_Grupo: formData.ID_Documento_Grupo || null,      
        ID_Intercambio: formData.ID_Intercambio || null,
        Visivel: formData.Visivel,
        Ativo: formData.Ativo
      }
    }, {
      headers: {
        "X-CSRF-Token": csrfToken
      }
    });

   console.log('Erro response:', response);

    // Log completo da resposta
    if (response.success){
           window.location.href = '/permissao';
    } else {
      console.error('Erro inesperado na resposta da API:', response.data);
      alert('Erro ao salvar permissão1.');
    }
  } catch (error) {
    console.error('Erro ao salvar permissão:', error);
    alert('Erro ao salvar permissão2.');
  }
};

export default EditaPermissao;
